/**
 * Short synthesized tones, so the app ships no sound files. A phone only lets a page make sound
 * after the person has tapped it, so the first tap anywhere unlocks the audio for later cues (a
 * countdown nobody tapped to start).
 */

let ctx: AudioContext | null = null;

function unlock(): void {
  try {
    ctx ??= new AudioContext();
    void ctx.resume();
  } catch {
    /* no Web Audio: cues stay silent */
  }
}

if (typeof document !== 'undefined') {
  for (const type of ['pointerup', 'keydown'] as const) {
    document.addEventListener(type, unlock, { capture: true, passive: true });
  }
}

/** One sine tone. Silent until a tap has unlocked audio. */
export function tone(hz: number, ms: number): void {
  if (!ctx || ctx.state !== 'running') return;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.frequency.value = hz;
  // A quick fade in and out, or the tone clicks at both ends.
  const t = ctx.currentTime;
  gain.gain.setValueAtTime(0, t);
  gain.gain.linearRampToValueAtTime(0.25, t + 0.01);
  gain.gain.linearRampToValueAtTime(0, t + ms / 1000);
  osc.connect(gain).connect(ctx.destination);
  osc.start(t);
  osc.stop(t + ms / 1000 + 0.02);
}
